window.GreenBadgePlaces = {
  "dataVersion": "V6.1.5 Deutschlandbestand 15.07.2026",
  "source": "Lokaler Deutschlandbestand: deutsche Städte/Orte ab ungefähr 30.000 Einwohnern auf Basis eines GeoNames-Datenabzugs (WGS84, Population als Auswahlhilfe), ergänzt um touristische Ziele, Urlaubsregionen und Grenzorte/-regionen. Die amtliche Gemeindestruktur und Einwohnergrößen werden bei Aktualisierungen mit dem Destatis-Gemeindeverzeichnis abgeglichen.",
  "populationThreshold": 30000,
  "coordinateSystem": "WGS84",
  "privacy": "Alle Zielort- und Entfernungsabfragen laufen lokal im Shopify-Theme; beim Nutzer wird keine externe Geo-API aufgerufen.",
  "counts": {
    "total": 426,
    "cities": 326,
    "tourism": 57,
    "borderPlaces": 16,
    "regions": 18,
    "borderRegions": 9
  },
  "places": [
    {
      "name": "Aalen",
      "state": "Baden-Württemberg",
      "lat": 48.83777,
      "lng": 10.0933,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "aaleni"
      ],
      "population": 67085
    },
    {
      "name": "Albstadt",
      "state": "Baden-Württemberg",
      "lat": 48.21644,
      "lng": 9.02596,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Albshtat",
        "Al'bshtat",
        "Al'bshtadt"
      ],
      "population": 46664
    },
    {
      "name": "Backnang",
      "state": "Baden-Württemberg",
      "lat": 48.94743,
      "lng": 9.43718,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Baknang",
        "baknangh"
      ],
      "population": 35778
    },
    {
      "name": "Balingen",
      "state": "Baden-Württemberg",
      "lat": 48.27525,
      "lng": 8.85464,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "ba lin gen"
      ],
      "population": 34414
    },
    {
      "name": "Biberach an der Riß",
      "state": "Baden-Württemberg",
      "lat": 48.09345,
      "lng": 9.79053,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Biberakh an der Risu"
      ],
      "population": 32333
    },
    {
      "name": "Bruchsal",
      "state": "Baden-Württemberg",
      "lat": 49.12426,
      "lng": 8.59804,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bruchsalia"
      ],
      "population": 45364
    },
    {
      "name": "Böblingen",
      "state": "Baden-Württemberg",
      "lat": 48.68212,
      "lng": 9.01171,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Boeblingen",
        "Beblingen",
        "B'oblingen",
        "beblingeni",
        "Bjoblingen",
        "Byoblingen"
      ],
      "population": 46282
    },
    {
      "name": "Crailsheim",
      "state": "Baden-Württemberg",
      "lat": 49.13444,
      "lng": 10.07193,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "ICrailsheim",
        "Crailsheimum"
      ],
      "population": 32262
    },
    {
      "name": "Esslingen",
      "state": "Baden-Württemberg",
      "lat": 48.73961,
      "lng": 9.30473,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Eslingen",
        "Eszlingen"
      ],
      "population": 92390
    },
    {
      "name": "Ettlingen",
      "state": "Baden-Württemberg",
      "lat": 48.94094,
      "lng": 8.40763,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Etlingen",
        "Ehttlingen"
      ],
      "population": 38942
    },
    {
      "name": "Fellbach",
      "state": "Baden-Württemberg",
      "lat": 48.80912,
      "lng": 9.27697,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Fell'bakh"
      ],
      "population": 43935
    },
    {
      "name": "Filderstadt",
      "state": "Baden-Württemberg",
      "lat": 48.65698,
      "lng": 9.22049,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Fildershtat",
        "Fil'dershtadt"
      ],
      "population": 43550
    },
    {
      "name": "Freiburg im Breisgau",
      "state": "Baden-Württemberg",
      "lat": 47.999,
      "lng": 7.8421,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Freiburg",
        "Fribourg-en-Brisgau",
        "Friburgo in Brisgovia"
      ],
      "population": 215966
    },
    {
      "name": "Göppingen",
      "state": "Baden-Württemberg",
      "lat": 48.70354,
      "lng": 9.65209,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Goeppingen",
        "Gepingen",
        "G'opingen",
        "Geppingen",
        "Gjoppingen"
      ],
      "population": 58040
    },
    {
      "name": "Heidenheim an der Brenz",
      "state": "Baden-Württemberg",
      "lat": 48.67798,
      "lng": 10.15162,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 50067
    },
    {
      "name": "Heilbronn",
      "state": "Baden-Württemberg",
      "lat": 49.13995,
      "lng": 9.22054,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Heilbronas"
      ],
      "population": 120733
    },
    {
      "name": "Herrenberg",
      "state": "Baden-Württemberg",
      "lat": 48.59523,
      "lng": 8.86648,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Herenberg",
        "Gerrenberg",
        "herenbergi",
        "Herrenberq",
        "Kherenberg",
        "Kherrenberg"
      ],
      "population": 32649
    },
    {
      "name": "Karlsruhe",
      "state": "Baden-Württemberg",
      "lat": 49.0069,
      "lng": 8.4037,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Kallsruh",
        "Karlsrue",
        "karlsrwh",
        "Carlsruhe",
        "Karlsroue",
        "Karlsrueh",
        "Karlsruje",
        "karlsaruha"
      ],
      "population": 283799
    },
    {
      "name": "Kirchheim unter Teck",
      "state": "Baden-Württemberg",
      "lat": 48.64683,
      "lng": 9.45378,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 40206
    },
    {
      "name": "Lahr/Schwarzwald",
      "state": "Baden-Württemberg",
      "lat": 48.34042,
      "lng": 7.86886,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Lahr"
      ],
      "population": 47551
    },
    {
      "name": "Leinfelden-Echterdingen",
      "state": "Baden-Württemberg",
      "lat": 48.69406,
      "lng": 9.16809,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Laynfelden Exterdingen",
        "Lajnfelden-Ekhterdingen",
        "Lajnfel'den-Ehkhterdingen",
        "Ljajnfel'den-Ekhterdingen"
      ],
      "population": 36672
    },
    {
      "name": "Leonberg",
      "state": "Baden-Württemberg",
      "lat": 48.8,
      "lng": 9.01667,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Leonberq",
        "leonbergi",
        "Leonsberg"
      ],
      "population": 45711
    },
    {
      "name": "Mannheim",
      "state": "Baden-Württemberg",
      "lat": 49.4875,
      "lng": 8.466,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Manheima",
        "Manheimas",
        "Manhemium"
      ],
      "population": 307960
    },
    {
      "name": "Nürtingen",
      "state": "Baden-Württemberg",
      "lat": 48.62565,
      "lng": 9.34203,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Nuertingen",
        "Nurtinga",
        "Nirtingen",
        "Njurtingen",
        "Nyurtingen"
      ],
      "population": 40210
    },
    {
      "name": "Offenburg",
      "state": "Baden-Württemberg",
      "lat": 48.47377,
      "lng": 7.94495,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Ofenburg",
        "Offenbourg",
        "Offenburgum"
      ],
      "population": 59238
    },
    {
      "name": "Ostfildern",
      "state": "Baden-Württemberg",
      "lat": 48.72704,
      "lng": 9.24954,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 33598
    },
    {
      "name": "Radolfzell",
      "state": "Baden-Württemberg",
      "lat": 47.74194,
      "lng": 8.97098,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Radol'fcell'"
      ],
      "population": 30096
    },
    {
      "name": "Rastatt",
      "state": "Baden-Württemberg",
      "lat": 48.85851,
      "lng": 8.20965,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "rastat",
        "Rashtat",
        "Rashtatt",
        "rashutatto"
      ],
      "population": 47906
    },
    {
      "name": "Ravensburg",
      "state": "Baden-Württemberg",
      "lat": 47.78198,
      "lng": 9.61062,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Ravenzburg",
        "Ravensbourg",
        "Ravensburgas"
      ],
      "population": 48825
    },
    {
      "name": "Reutlingen",
      "state": "Baden-Württemberg",
      "lat": 48.49144,
      "lng": 9.20427,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Rejtlingen"
      ],
      "population": 112627
    },
    {
      "name": "Rheinfelden (Baden)",
      "state": "Baden-Württemberg",
      "lat": 47.56013,
      "lng": 7.78715,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Rheinfelden"
      ],
      "population": 32535
    },
    {
      "name": "Rottenburg am Neckar",
      "state": "Baden-Württemberg",
      "lat": 48.47629,
      "lng": 8.93528,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Rottenburg"
      ],
      "population": 42721
    },
    {
      "name": "Schorndorf",
      "state": "Baden-Württemberg",
      "lat": 48.80537,
      "lng": 9.52721,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Shorndorf"
      ],
      "population": 39697
    },
    {
      "name": "Schwäbisch Gmünd",
      "state": "Baden-Württemberg",
      "lat": 48.79947,
      "lng": 9.79809,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Schwaebisch Gmuend"
      ],
      "population": 61216
    },
    {
      "name": "Schwäbisch Hall",
      "state": "Baden-Württemberg",
      "lat": 49.11127,
      "lng": 9.73908,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Schwaebisch Hall"
      ],
      "population": 36543
    },
    {
      "name": "Sindelfingen",
      "state": "Baden-Württemberg",
      "lat": 48.7,
      "lng": 9.01667,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Zindelfingen",
        "Zindel'fingen"
      ],
      "population": 61311
    },
    {
      "name": "Sinsheim",
      "state": "Baden-Württemberg",
      "lat": 49.2529,
      "lng": 8.87867,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 35219
    },
    {
      "name": "Tuttlingen",
      "state": "Baden-Württemberg",
      "lat": 47.98464,
      "lng": 8.8177,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Tutlingen"
      ],
      "population": 34847
    },
    {
      "name": "Tübingen",
      "state": "Baden-Württemberg",
      "lat": 48.5216,
      "lng": 9.0576,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Tibingen",
        "Tybingen",
        "Cjubingen",
        "ITübingen",
        "Tibingene",
        "Tjubingen",
        "Tuebingen",
        "ITuebingen",
        "teyubingen",
        "tu bin gen",
        "Tiubingenas"
      ],
      "population": 83416
    },
    {
      "name": "Ulm",
      "state": "Baden-Württemberg",
      "lat": 48.4011,
      "lng": 9.9876,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 120451
    },
    {
      "name": "Villingen-Schwenningen",
      "state": "Baden-Württemberg",
      "lat": 48.06226,
      "lng": 8.49358,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Filingen-Shveningen",
        "Fillingen-Shvenningen",
        "Villingen-Shvenningen"
      ],
      "population": 81770
    },
    {
      "name": "Waiblingen",
      "state": "Baden-Württemberg",
      "lat": 48.83241,
      "lng": 9.31641,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Waiblinga"
      ],
      "population": 52945
    },
    {
      "name": "Weinheim",
      "state": "Baden-Württemberg",
      "lat": 49.54887,
      "lng": 8.66697,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 43325
    },
    {
      "name": "Baden-Baden",
      "state": "Baden-Württemberg",
      "lat": 48.7606,
      "lng": 8.2398,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "badn badn",
        "badenbaden",
        "Badenbadene",
        "Badehn-Badehn",
        "ba deng-ba deng",
        "Badenas-Badenas"
      ],
      "population": 55449
    },
    {
      "name": "Freudenstadt",
      "state": "Baden-Württemberg",
      "lat": 48.46695,
      "lng": 8.41371,
      "type": "tourism",
      "hasZone": false,
      "aliases": [],
      "population": 23868
    },
    {
      "name": "Friedrichshafen",
      "state": "Baden-Württemberg",
      "lat": 47.65,
      "lng": 9.48,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Fridrixshafen",
        "Fridrikhsgafen",
        "Fridrikhskhafen"
      ],
      "population": 58403
    },
    {
      "name": "Gengenbach",
      "state": "Baden-Württemberg",
      "lat": 48.40476,
      "lng": 8.01433,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Gengenbakh"
      ],
      "population": 11234
    },
    {
      "name": "Heidelberg",
      "state": "Baden-Württemberg",
      "lat": 49.3988,
      "lng": 8.6724,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Edelberga",
        "Heidlbeag",
        "Heidlberg",
        "Heidelbarg",
        "Heidelburg",
        "Heydelberg",
        "haidelbergi",
        "Heidelbaerg",
        "Heidelberch",
        "Heidelberga",
        "Hejdelbergo",
        "Heidelbergas"
      ],
      "population": 143345
    },
    {
      "name": "Konstanz",
      "state": "Baden-Württemberg",
      "lat": 47.6779,
      "lng": 9.1732,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Costanza",
        "Konstanc",
        "Constance",
        "Constanza",
        "Konstanca",
        "Konstanco",
        "Konstantza"
      ],
      "population": 81275
    },
    {
      "name": "Meersburg",
      "state": "Baden-Württemberg",
      "lat": 47.6942,
      "lng": 9.2711,
      "type": "tourism",
      "hasZone": false,
      "aliases": []
    },
    {
      "name": "Rust",
      "state": "Baden-Württemberg",
      "lat": 48.26667,
      "lng": 7.73333,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Europa Park"
      ],
      "population": 3577
    },
    {
      "name": "Titisee-Neustadt",
      "state": "Baden-Württemberg",
      "lat": 47.92104,
      "lng": 8.19063,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Titisee",
        "Hochschwarzwald"
      ],
      "population": 12019
    },
    {
      "name": "Triberg im Schwarzwald",
      "state": "Baden-Württemberg",
      "lat": 48.13175,
      "lng": 8.23317,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Triberg",
        "Triberger Wasserfälle",
        "Triberger Wasserfaelle",
        "Triberg im Shvarcvald",
        "trybrg aym shwarzwald"
      ],
      "population": 5275
    },
    {
      "name": "Kehl",
      "state": "Baden-Württemberg",
      "lat": 48.57297,
      "lng": 7.81523,
      "type": "border",
      "hasZone": false,
      "aliases": [],
      "population": 34009
    },
    {
      "name": "Lörrach",
      "state": "Baden-Württemberg",
      "lat": 47.61497,
      "lng": 7.66457,
      "type": "border",
      "hasZone": false,
      "aliases": [
        "Loerrach"
      ],
      "population": 47002
    },
    {
      "name": "Singen (Hohentwiel)",
      "state": "Baden-Württemberg",
      "lat": 47.75935,
      "lng": 8.8403,
      "type": "border",
      "hasZone": false,
      "aliases": [
        "Singen",
        "Zingen",
        "singena"
      ],
      "population": 48033
    },
    {
      "name": "Waldshut-Tiengen",
      "state": "Baden-Württemberg",
      "lat": 47.62323,
      "lng": 8.21717,
      "type": "border",
      "hasZone": false,
      "aliases": [
        "Valdskhut-Tingen",
        "Val'dskhut-Tingen"
      ],
      "population": 22404
    },
    {
      "name": "Weil am Rhein",
      "state": "Baden-Württemberg",
      "lat": 47.59331,
      "lng": 7.62082,
      "type": "border",
      "hasZone": false,
      "aliases": [],
      "population": 29548
    },
    {
      "name": "Bodensee",
      "state": "Baden-Württemberg",
      "lat": 47.66,
      "lng": 9.18,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Lake Constance",
        "Bodamské jezero",
        "Lac de Constance",
        "Lago di Costanza",
        "Jezioro Bodeńskie"
      ]
    },
    {
      "name": "Schwarzwald",
      "state": "Baden-Württemberg",
      "lat": 48.2,
      "lng": 8.15,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Czarny Las",
        "Foret Noire",
        "Selva Negra",
        "Zwarte Woud",
        "Black Forest"
      ]
    },
    {
      "name": "Deutsch-französische Grenze",
      "state": "Baden-Württemberg",
      "lat": 48.35,
      "lng": 7.75,
      "type": "border_region",
      "hasZone": false,
      "aliases": [
        "French border",
        "Grenze Frankreich",
        "German-French border",
        "Deutsch-franzoesische Grenze"
      ]
    },
    {
      "name": "Deutsch-schweizer Grenze",
      "state": "Baden-Württemberg",
      "lat": 47.65,
      "lng": 8.65,
      "type": "border_region",
      "hasZone": false,
      "aliases": [
        "Swiss border",
        "Grenze Schweiz",
        "German-Swiss border"
      ]
    },
    {
      "name": "Amberg",
      "state": "Bayern",
      "lat": 49.44287,
      "lng": 11.86267,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "ambrg",
        "Anberg",
        "aymbrg",
        "Ambergas"
      ],
      "population": 44737
    },
    {
      "name": "Ansbach",
      "state": "Bayern",
      "lat": 49.30481,
      "lng": 10.5931,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Ansbakh",
        "Ansbachas"
      ],
      "population": 31839
    },
    {
      "name": "Aschaffenburg",
      "state": "Bayern",
      "lat": 49.97704,
      "lng": 9.15214,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Asafenburga",
        "Ashafenburg",
        "Ashaffenburg",
        "Aschaffenbourg",
        "Auscheffenburg",
        "Aschaffenburgum"
      ],
      "population": 68551
    },
    {
      "name": "Bamberg",
      "state": "Bayern",
      "lat": 49.8917,
      "lng": 10.886,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "bmbrg",
        "bambrg",
        "Bambarg",
        "Bamberk",
        "bambrgh",
        "Bamberga",
        "bambergi",
        "Bambergas"
      ],
      "population": 70047
    },
    {
      "name": "Bayreuth",
      "state": "Bayern",
      "lat": 49.9456,
      "lng": 11.5713,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bayreith"
      ],
      "population": 75061
    },
    {
      "name": "Coburg",
      "state": "Bayern",
      "lat": 50.25937,
      "lng": 10.96384,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Koburg",
        "Cobourg",
        "Coburgo",
        "Coburgum"
      ],
      "population": 41901
    },
    {
      "name": "Dachau",
      "state": "Bayern",
      "lat": 48.26,
      "lng": 11.43402,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "dahau",
        "dahhau",
        "Dakhau",
        "Dochau",
        "Dachanum"
      ],
      "population": 39740
    },
    {
      "name": "Deggendorf",
      "state": "Bayern",
      "lat": 48.84085,
      "lng": 12.96068,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Degndorf",
        "Degendorf",
        "Dehgendorf",
        "Degendorfas"
      ],
      "population": 31081
    },
    {
      "name": "Erding",
      "state": "Bayern",
      "lat": 48.30603,
      "lng": 11.90686,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Aerding",
        "Ehrding",
        "Erdingas"
      ],
      "population": 33519
    },
    {
      "name": "Erlangen",
      "state": "Bayern",
      "lat": 49.5897,
      "lng": 11.0119,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "earangen",
        "Erlanken",
        "Ehrlangen",
        "Erlangene",
        "Erlangenas"
      ],
      "population": 102675
    },
    {
      "name": "Forchheim",
      "state": "Bayern",
      "lat": 49.71754,
      "lng": 11.05877,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Forchheimas"
      ],
      "population": 30442
    },
    {
      "name": "Freising",
      "state": "Bayern",
      "lat": 48.40351,
      "lng": 11.74876,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Freysing",
        "Frisinga"
      ],
      "population": 42570
    },
    {
      "name": "Fürstenfeldbruck",
      "state": "Bayern",
      "lat": 48.17904,
      "lng": 11.2547,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Fuerstenfeldbruck",
        "Firstenfeldbruk",
        "Fjurstenfeldbruk",
        "Fjurstenfel'dbruk",
        "Fiurstenfeldbrukas"
      ],
      "population": 33533
    },
    {
      "name": "Fürth",
      "state": "Bayern",
      "lat": 49.4771,
      "lng": 10.9887,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Fuerth"
      ],
      "population": 112025
    },
    {
      "name": "Germering",
      "state": "Bayern",
      "lat": 48.13392,
      "lng": 11.3765,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Germeringas"
      ],
      "population": 40511
    },
    {
      "name": "Hof",
      "state": "Bayern",
      "lat": 50.31297,
      "lng": 11.91261,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 49239
    },
    {
      "name": "Ingolstadt",
      "state": "Bayern",
      "lat": 48.7665,
      "lng": 11.4258,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Ingolshtat",
        "Ingol'shtadt"
      ],
      "population": 120658
    },
    {
      "name": "Kaufbeuren",
      "state": "Bayern",
      "lat": 47.88238,
      "lng": 10.62192,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Kaufbeiren"
      ],
      "population": 42505
    },
    {
      "name": "Kempten (Allgäu)",
      "state": "Bayern",
      "lat": 47.72674,
      "lng": 10.31389,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Kempten (Allgaeu)"
      ],
      "population": 61399
    },
    {
      "name": "Landshut",
      "state": "Bayern",
      "lat": 48.5442,
      "lng": 12.1469,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Landsgut",
        "landshwt",
        "Landshuad",
        "Landskhut",
        "lan dshuth",
        "Landishuta",
        "Landshutas"
      ],
      "population": 60488
    },
    {
      "name": "Memmingen",
      "state": "Bayern",
      "lat": 47.98372,
      "lng": 10.18527,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Memingen"
      ],
      "population": 41135
    },
    {
      "name": "Neu-Ulm",
      "state": "Bayern",
      "lat": 48.39279,
      "lng": 10.01112,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Nei-Ulm"
      ],
      "population": 51389
    },
    {
      "name": "Neumarkt in der Oberpfalz",
      "state": "Bayern",
      "lat": 49.28028,
      "lng": 11.46278,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Nojmarkt in der Oberpfalc",
        "Nojmarkt-in-der-Oberpfal'c",
        "Stadt Neumarkt in der Oberpfalz"
      ],
      "population": 39557
    },
    {
      "name": "Nürnberg",
      "state": "Bayern",
      "lat": 49.4521,
      "lng": 11.0767,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Nirnberg",
        "Nürnbarg",
        "Nürnberq",
        "Nirnberga",
        "Njurnberg",
        "Nuernbarg",
        "Nuernberg",
        "Nuernberq",
        "Nuremberg",
        "Nurenberg",
        "Nurenburg",
        "Nyurnberg"
      ],
      "population": 515543
    },
    {
      "name": "Passau",
      "state": "Bayern",
      "lat": 48.5667,
      "lng": 13.4319,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Pasau",
        "Passaou"
      ],
      "population": 50560
    },
    {
      "name": "Rosenheim",
      "state": "Bayern",
      "lat": 47.85637,
      "lng": 12.12247,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 60167
    },
    {
      "name": "Schwabach",
      "state": "Bayern",
      "lat": 49.33047,
      "lng": 11.02346,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "shwabakh"
      ],
      "population": 38554
    },
    {
      "name": "Schweinfurt",
      "state": "Bayern",
      "lat": 50.04937,
      "lng": 10.22175,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 54012
    },
    {
      "name": "Straubing",
      "state": "Bayern",
      "lat": 48.88126,
      "lng": 12.57385,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Shtraubing"
      ],
      "population": 44580
    },
    {
      "name": "Weiden in der Oberpfalz",
      "state": "Bayern",
      "lat": 49.67682,
      "lng": 12.15613,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Weiden"
      ],
      "population": 42550
    },
    {
      "name": "Würzburg",
      "state": "Bayern",
      "lat": 49.7913,
      "lng": 9.9534,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "wrzbrg",
        "Wuerzburg",
        "Wurzburgo",
        "Wurtzbourg",
        "Wurtzburgo"
      ],
      "population": 133731
    },
    {
      "name": "Bad Reichenhall",
      "state": "Bayern",
      "lat": 47.72947,
      "lng": 12.87819,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Reichenhall"
      ],
      "population": 16910
    },
    {
      "name": "Berchtesgaden",
      "state": "Bayern",
      "lat": 47.6324,
      "lng": 13.0012,
      "type": "tourism",
      "hasZone": false,
      "aliases": []
    },
    {
      "name": "Dinkelsbühl",
      "state": "Bayern",
      "lat": 49.06942,
      "lng": 10.31985,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Dinkelsbuehl",
        "Dinkelsbil",
        "Dinkelsbyul",
        "Dinkel'sbjul'",
        "Dinkelsbiulis"
      ],
      "population": 11882
    },
    {
      "name": "Füssen",
      "state": "Bayern",
      "lat": 47.5696,
      "lng": 10.7004,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Fuessen",
        "Neuschwanstein"
      ]
    },
    {
      "name": "Garmisch-Partenkirchen",
      "state": "Bayern",
      "lat": 47.4921,
      "lng": 11.0958,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Garmisch"
      ]
    },
    {
      "name": "Lindau",
      "state": "Bayern",
      "lat": 47.5442,
      "lng": 9.6839,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Lindau Bodensee"
      ]
    },
    {
      "name": "Mittenwald",
      "state": "Bayern",
      "lat": 47.4422,
      "lng": 11.26187,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Mitenvald",
        "Mittenval'd"
      ],
      "population": 7996
    },
    {
      "name": "Oberammergau",
      "state": "Bayern",
      "lat": 47.59812,
      "lng": 11.06692,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Passionsspiele Oberammergau",
        "Oberamergau"
      ],
      "population": 5344
    },
    {
      "name": "Oberstdorf",
      "state": "Bayern",
      "lat": 47.40724,
      "lng": 10.27939,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Allgaeu Alps",
        "Allgäuer Alpen"
      ],
      "population": 9572
    },
    {
      "name": "Prien am Chiemsee",
      "state": "Bayern",
      "lat": 47.85602,
      "lng": 12.34623,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Chiemsee",
        "Herrenchiemsee",
        "Prean am Cheamsee"
      ],
      "population": 10872
    },
    {
      "name": "Rothenburg ob der Tauber",
      "state": "Bayern",
      "lat": 49.3802,
      "lng": 10.1867,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Rothenburg"
      ]
    },
    {
      "name": "Tegernsee",
      "state": "Bayern",
      "lat": 47.7123,
      "lng": 11.7582,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Tegernze"
      ],
      "population": 3770
    },
    {
      "name": "Freilassing",
      "state": "Bayern",
      "lat": 47.84085,
      "lng": 12.98114,
      "type": "border",
      "hasZone": false,
      "aliases": [],
      "population": 15909
    },
    {
      "name": "Allgäu",
      "state": "Bayern",
      "lat": 47.73,
      "lng": 10.31,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Allgaeu",
        "Allgäu Alps",
        "Allgaeu Alps"
      ]
    },
    {
      "name": "Bayerischer Wald",
      "state": "Bayern",
      "lat": 49.03,
      "lng": 13.12,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Bavarian Forest"
      ]
    },
    {
      "name": "Chiemsee",
      "state": "Bayern",
      "lat": 47.87,
      "lng": 12.42,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Lake Chiemsee"
      ]
    },
    {
      "name": "Deutsch-tschechische Grenze",
      "state": "Bayern",
      "lat": 49.2,
      "lng": 12.8,
      "type": "border_region",
      "hasZone": false,
      "aliases": [
        "Czech border",
        "Grenze Tschechien",
        "German-Czech border"
      ]
    },
    {
      "name": "Deutsch-österreichische Grenze",
      "state": "Bayern",
      "lat": 47.65,
      "lng": 12.2,
      "type": "border_region",
      "hasZone": false,
      "aliases": [
        "Austrian border",
        "Grenze Österreich",
        "Grenze Oesterreich",
        "German-Austrian border",
        "Deutsch-oesterreichische Grenze"
      ]
    },
    {
      "name": "Bernau bei Berlin",
      "state": "Brandenburg",
      "lat": 52.67982,
      "lng": 13.58708,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bernau baj Berlin",
        "Bernau kaj Berlin"
      ],
      "population": 34866
    },
    {
      "name": "Brandenburg an der Havel",
      "state": "Brandenburg",
      "lat": 52.4125,
      "lng": 12.5316,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Brandenburg",
        "Brannenborg an de Havel",
        "Brandenburg un der Havel"
      ],
      "population": 59826
    },
    {
      "name": "Cottbus",
      "state": "Brandenburg",
      "lat": 51.7563,
      "lng": 14.3329,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Kottbus"
      ],
      "population": 84754
    },
    {
      "name": "Eberswalde",
      "state": "Brandenburg",
      "lat": 52.83492,
      "lng": 13.81951,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Ebersvalde",
        "Ebersval'de"
      ],
      "population": 41980
    },
    {
      "name": "Eisenhüttenstadt",
      "state": "Brandenburg",
      "lat": 52.15,
      "lng": 14.65,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Eisenhuettenstadt",
        "Iesenhüttenstadt",
        "Iesenhuettenstadt"
      ],
      "population": 32052
    },
    {
      "name": "Falkensee",
      "state": "Brandenburg",
      "lat": 52.56014,
      "lng": 13.0927,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Falkenze"
      ],
      "population": 37468
    },
    {
      "name": "Frankfurt (Oder)",
      "state": "Brandenburg",
      "lat": 52.3472,
      "lng": 14.5506,
      "type": "city",
      "hasZone": false,
      "aliases": []
    },
    {
      "name": "Fürstenwalde/Spree",
      "state": "Brandenburg",
      "lat": 52.36067,
      "lng": 14.06185,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Fürstenwalde",
        "Fuerstenwalde/Spree"
      ],
      "population": 33539
    },
    {
      "name": "Königs Wusterhausen",
      "state": "Brandenburg",
      "lat": 52.30141,
      "lng": 13.633,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Koenigs Wusterhausen",
        "Kenigs Vusterkhauzen",
        "Kjonigs-Vusterkhauzen"
      ],
      "population": 32513
    },
    {
      "name": "Neuruppin",
      "state": "Brandenburg",
      "lat": 52.92815,
      "lng": 12.80311,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Neuruppino"
      ],
      "population": 31901
    },
    {
      "name": "Oranienburg",
      "state": "Brandenburg",
      "lat": 52.75577,
      "lng": 13.24197,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Oraninburg",
        "Aranienburg",
        "oranienburuku"
      ],
      "population": 40793
    },
    {
      "name": "Potsdam",
      "state": "Brandenburg",
      "lat": 52.3906,
      "lng": 13.0645,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Poczdam",
        "Potsdamo",
        "potsudamu"
      ],
      "population": 182112
    },
    {
      "name": "Schwedt (Oder)",
      "state": "Brandenburg",
      "lat": 53.05963,
      "lng": 14.28154,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 30189
    },
    {
      "name": "Lübbenau/Spreewald",
      "state": "Brandenburg",
      "lat": 51.86217,
      "lng": 13.95168,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Lubnjow",
        "Lübbenau",
        "Luebbenau",
        "Spreewald",
        "Luebbenau/Spreewald"
      ],
      "population": 17461
    },
    {
      "name": "Forst (Lausitz)",
      "state": "Brandenburg",
      "lat": 51.73544,
      "lng": 14.63971,
      "type": "border",
      "hasZone": false,
      "aliases": [
        "Forst"
      ],
      "population": 22843
    },
    {
      "name": "Guben",
      "state": "Brandenburg",
      "lat": 51.94993,
      "lng": 14.7055,
      "type": "border",
      "hasZone": false,
      "aliases": [
        "gu ben",
        "Gubenas"
      ],
      "population": 21608
    },
    {
      "name": "Spreewald",
      "state": "Brandenburg",
      "lat": 51.88,
      "lng": 13.96,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Spree Forest"
      ]
    },
    {
      "name": "Deutsch-polnische Grenze",
      "state": "Brandenburg",
      "lat": 52.0,
      "lng": 14.6,
      "type": "border_region",
      "hasZone": false,
      "aliases": [
        "Grenze Polen",
        "Polish border",
        "German-Polish border"
      ]
    },
    {
      "name": "Bremerhaven",
      "state": "Bremen",
      "lat": 53.55357,
      "lng": 8.57553,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bremerhafene",
        "bremerhaveni",
        "Bremerhoawen",
        "Bremerkhafen",
        "Bremerhafenas"
      ],
      "population": 113557
    },
    {
      "name": "Hamburg",
      "state": "Hamburg",
      "lat": 53.5511,
      "lng": 9.9937,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Amburgo",
        "Amburgu",
        "Gamburg",
        "Hamborg",
        "Hamburk",
        "hambwrg",
        "Ħamburg",
        "Hambourg",
        "Hamburga",
        "hamburgi",
        "Hamburgo",
        "Hamburgu"
      ],
      "population": 1845229
    },
    {
      "name": "Bad Hersfeld",
      "state": "Hessen",
      "lat": 50.87197,
      "lng": 9.70891,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "bad hrsfld",
        "Bad Khersfeld",
        "Bad-Gersfel'd",
        "Bad-Khersfel'd"
      ],
      "population": 30725
    },
    {
      "name": "Bad Homburg vor der Höhe",
      "state": "Hessen",
      "lat": 50.22683,
      "lng": 8.61816,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bad Homburg vor der Hoehe",
        "Homburg vor der Hohe",
        "Bad Homburg v.d. Höhe",
        "Bad Homburg v.d. Hoehe"
      ],
      "population": 51859
    },
    {
      "name": "Bad Nauheim",
      "state": "Hessen",
      "lat": 50.36463,
      "lng": 8.73859,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 30291
    },
    {
      "name": "Bad Vilbel",
      "state": "Hessen",
      "lat": 50.17866,
      "lng": 8.73756,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bad-Fil'bel'"
      ],
      "population": 30736
    },
    {
      "name": "Bensheim",
      "state": "Hessen",
      "lat": 49.68369,
      "lng": 8.61839,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 39439
    },
    {
      "name": "Dietzenbach",
      "state": "Hessen",
      "lat": 50.00976,
      "lng": 8.77783,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 33256
    },
    {
      "name": "Dreieich",
      "state": "Hessen",
      "lat": 50.01997,
      "lng": 8.69611,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 40367
    },
    {
      "name": "Fulda",
      "state": "Hessen",
      "lat": 50.5558,
      "lng": 9.6808,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Ful'da"
      ],
      "population": 63760
    },
    {
      "name": "Gießen",
      "state": "Hessen",
      "lat": 50.5841,
      "lng": 8.6784,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Gisen",
        "Gissen",
        "Gieseni"
      ],
      "population": 74411
    },
    {
      "name": "Hanau",
      "state": "Hessen",
      "lat": 50.13423,
      "lng": 8.91418,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Hanau am Main",
        "Khanau",
        "Chanaou"
      ],
      "population": 88648
    },
    {
      "name": "Hofheim am Taunus",
      "state": "Hessen",
      "lat": 50.09019,
      "lng": 8.4493,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Hofheim in Taunus",
        "Khofkhajm am Taunus"
      ],
      "population": 37750
    },
    {
      "name": "Kassel",
      "state": "Hessen",
      "lat": 51.3127,
      "lng": 9.4797,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Kasel",
        "Cassel",
        "Kasele",
        "Kaseli",
        "Kaselo"
      ],
      "population": 194501
    },
    {
      "name": "Lampertheim",
      "state": "Hessen",
      "lat": 49.59786,
      "lng": 8.4725,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 31635
    },
    {
      "name": "Langen",
      "state": "Hessen",
      "lat": 49.98955,
      "lng": 8.66852,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "langn",
        "langhn",
        "rangen"
      ],
      "population": 35416
    },
    {
      "name": "Maintal",
      "state": "Hessen",
      "lat": 50.15,
      "lng": 8.83333,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Majntal",
        "mayntal"
      ],
      "population": 38313
    },
    {
      "name": "Mörfelden-Walldorf",
      "state": "Hessen",
      "lat": 49.99472,
      "lng": 8.58361,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Moerfelden-Walldorf",
        "Merfelden-Valdorf",
        "Merfel'den-Vall'dorf",
        "Mjorfel'den-Val'dorf",
        "Mjorfel'dehn-Val'dorf"
      ],
      "population": 32753
    },
    {
      "name": "Neu-Isenburg",
      "state": "Hessen",
      "lat": 50.04832,
      "lng": 8.69406,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Neulsenburg"
      ],
      "population": 35293
    },
    {
      "name": "Oberursel",
      "state": "Hessen",
      "lat": 50.20731,
      "lng": 8.57747,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 46678
    },
    {
      "name": "Rodgau",
      "state": "Hessen",
      "lat": 50.02627,
      "lng": 8.88588,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 43315
    },
    {
      "name": "Rüsselsheim",
      "state": "Hessen",
      "lat": 49.9885,
      "lng": 8.4215,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Ruesselsheim",
        "Rüsselsheim am Main"
      ],
      "population": 59730
    },
    {
      "name": "Viernheim",
      "state": "Hessen",
      "lat": 49.54033,
      "lng": 8.5782,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 32620
    },
    {
      "name": "Wetzlar",
      "state": "Hessen",
      "lat": 50.5611,
      "lng": 8.5049,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Vetzlar",
        "Wetzlaria"
      ],
      "population": 52656
    },
    {
      "name": "Rüdesheim am Rhein",
      "state": "Hessen",
      "lat": 49.9789,
      "lng": 7.9244,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Ruedesheim",
        "Rüdesheim",
        "Rudesheim"
      ]
    },
    {
      "name": "Greifswald",
      "state": "Mecklenburg-Vorpommern",
      "lat": 54.08905,
      "lng": 13.40244,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Universitäts- und Hansestadt Greifswald",
        "Griefswald",
        "Greifsvalde"
      ],
      "population": 52731
    },
    {
      "name": "Güstrow",
      "state": "Mecklenburg-Vorpommern",
      "lat": 53.7972,
      "lng": 12.17337,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Guestrow"
      ],
      "population": 31217
    },
    {
      "name": "Neubrandenburg",
      "state": "Mecklenburg-Vorpommern",
      "lat": 53.56414,
      "lng": 13.27532,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Nojbrandenburg",
        "Neibrandenburga",
        "Neubrandenbourg",
        "Nojbrandenburge"
      ],
      "population": 68082
    },
    {
      "name": "Rostock",
      "state": "Mecklenburg-Vorpommern",
      "lat": 54.0924,
      "lng": 12.0991,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Rostok",
        "Roshtok",
        "Rostoka"
      ],
      "population": 198293
    },
    {
      "name": "Schwerin",
      "state": "Mecklenburg-Vorpommern",
      "lat": 53.6355,
      "lng": 11.4012,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Swerin",
        "ch weri n"
      ],
      "population": 96641
    },
    {
      "name": "Wismar",
      "state": "Mecklenburg-Vorpommern",
      "lat": 53.89218,
      "lng": 11.45563,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Vismar",
        "Wismer",
        "Wysmar"
      ],
      "population": 45255
    },
    {
      "name": "Heringsdorf",
      "state": "Mecklenburg-Vorpommern",
      "lat": 53.95379,
      "lng": 14.16852,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Usedom",
        "Kaiserbäder",
        "Kaiserbaeder",
        "Seebad Heringsdorf"
      ],
      "population": 3517
    },
    {
      "name": "Rügen",
      "state": "Mecklenburg-Vorpommern",
      "lat": 54.4,
      "lng": 13.4,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Binz",
        "Rugia",
        "Ruegen",
        "Island of Rügen"
      ]
    },
    {
      "name": "Stralsund",
      "state": "Mecklenburg-Vorpommern",
      "lat": 54.3091,
      "lng": 13.0818,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Shtralzund",
        "Stralsunda",
        "Stralzunde"
      ],
      "population": 58976
    },
    {
      "name": "Waren (Müritz)",
      "state": "Mecklenburg-Vorpommern",
      "lat": 53.5204,
      "lng": 12.67985,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Waren",
        "Müritz",
        "Mueritz",
        "Waren (Mueritz)"
      ],
      "population": 21470
    },
    {
      "name": "Warnemünde",
      "state": "Mecklenburg-Vorpommern",
      "lat": 54.1767,
      "lng": 12.08402,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Warnemuende",
        "Warnemünn",
        "Varnemjunde"
      ],
      "population": 8441
    },
    {
      "name": "Ostsee",
      "state": "Mecklenburg-Vorpommern",
      "lat": 54.15,
      "lng": 12.0,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Ostseeküste",
        "Ostseekueste",
        "Baltic Sea coast"
      ]
    },
    {
      "name": "Usedom",
      "state": "Mecklenburg-Vorpommern",
      "lat": 53.94,
      "lng": 14.08,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Island of Usedom"
      ]
    },
    {
      "name": "Achim",
      "state": "Niedersachsen",
      "lat": 53.01416,
      "lng": 9.0263,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 30013
    },
    {
      "name": "Aurich",
      "state": "Niedersachsen",
      "lat": 53.46919,
      "lng": 7.48232,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Aurikh",
        "Aurichas"
      ],
      "population": 40319
    },
    {
      "name": "Bramsche",
      "state": "Niedersachsen",
      "lat": 52.40881,
      "lng": 7.97288,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bramshe"
      ],
      "population": 31394
    },
    {
      "name": "Braunschweig",
      "state": "Niedersachsen",
      "lat": 52.2689,
      "lng": 10.5268,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Brunswick",
        "Braunshweyg"
      ],
      "population": 244715
    },
    {
      "name": "Buchholz in der Nordheide",
      "state": "Niedersachsen",
      "lat": 53.32641,
      "lng": 9.86812,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 40849
    },
    {
      "name": "Burgdorf",
      "state": "Niedersachsen",
      "lat": 52.44628,
      "lng": 10.0064,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Burgdorfas"
      ],
      "population": 30899
    },
    {
      "name": "Buxtehude",
      "state": "Niedersachsen",
      "lat": 53.46716,
      "lng": 9.68636,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 38192
    },
    {
      "name": "Celle",
      "state": "Niedersachsen",
      "lat": 52.62264,
      "lng": 10.08047,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "chelle"
      ],
      "population": 71010
    },
    {
      "name": "Cloppenburg",
      "state": "Niedersachsen",
      "lat": 52.84754,
      "lng": 8.045,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Klopenburg",
        "Cloppenborg",
        "Kloppenburg"
      ],
      "population": 31177
    },
    {
      "name": "Delmenhorst",
      "state": "Niedersachsen",
      "lat": 53.0511,
      "lng": 8.63091,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Delmenkhorst",
        "Del'menkhorst",
        "Dehl'menkhorst"
      ],
      "population": 75893
    },
    {
      "name": "Emden",
      "state": "Niedersachsen",
      "lat": 53.36745,
      "lng": 7.20778,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Ehmden",
        "emuden",
        "Ehmdehn"
      ],
      "population": 51526
    },
    {
      "name": "Ganderkesee",
      "state": "Niedersachsen",
      "lat": 53.03333,
      "lng": 8.53333,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Ganderkeze"
      ],
      "population": 31141
    },
    {
      "name": "Garbsen",
      "state": "Niedersachsen",
      "lat": 52.41371,
      "lng": 9.5899,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Garbzen",
        "Garbseno"
      ],
      "population": 63355
    },
    {
      "name": "Georgsmarienhütte",
      "state": "Niedersachsen",
      "lat": 52.20296,
      "lng": 8.0448,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Georgsmarienhuette",
        "Georgsmarinkhite",
        "Georgsmarienkhjutte"
      ],
      "population": 32580
    },
    {
      "name": "Gifhorn",
      "state": "Niedersachsen",
      "lat": 52.47774,
      "lng": 10.5511,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Gifkhorn"
      ],
      "population": 43000
    },
    {
      "name": "Göttingen",
      "state": "Niedersachsen",
      "lat": 51.5413,
      "lng": 9.9158,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "gatingen",
        "Getingen",
        "Gottinga",
        "G'otingen",
        "gettingen",
        "Chöttingen",
        "Gjottingen",
        "Goettingen"
      ],
      "population": 122149
    },
    {
      "name": "Hameln",
      "state": "Niedersachsen",
      "lat": 52.10397,
      "lng": 9.35623,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "hamln",
        "Hamelen",
        "Hamelin",
        "Khameln",
        "Khamel'n"
      ],
      "population": 58666
    },
    {
      "name": "Hannover",
      "state": "Niedersachsen",
      "lat": 52.3759,
      "lng": 9.732,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Hanover",
        "Gannover",
        "Hannober",
        "Hannower",
        "Hanoveri",
        "Khanover",
        "Gannovehr",
        "Hannauver",
        "Hannovera",
        "Hannovere",
        "Hanoveris",
        "IHanoveri"
      ],
      "population": 515140
    },
    {
      "name": "Hildesheim",
      "state": "Niedersachsen",
      "lat": 52.1548,
      "lng": 9.9579,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Hildesheima",
        "Hildesheimas"
      ],
      "population": 103052
    },
    {
      "name": "Laatzen",
      "state": "Niedersachsen",
      "lat": 52.31506,
      "lng": 9.79739,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 40038
    },
    {
      "name": "Langenhagen",
      "state": "Niedersachsen",
      "lat": 52.44758,
      "lng": 9.73741,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "langnhagn",
        "Langenhogen",
        "Langenhageno",
        "Langenkhagen"
      ],
      "population": 50439
    },
    {
      "name": "Leer (Ostfriesland)",
      "state": "Niedersachsen",
      "lat": 53.23157,
      "lng": 7.461,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Leer"
      ],
      "population": 33886
    },
    {
      "name": "Lehrte",
      "state": "Niedersachsen",
      "lat": 52.37193,
      "lng": 9.97919,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Lerte"
      ],
      "population": 43920
    },
    {
      "name": "Lingen (Ems)",
      "state": "Niedersachsen",
      "lat": 52.52143,
      "lng": 7.31845,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Lingen"
      ],
      "population": 51310
    },
    {
      "name": "Melle",
      "state": "Niedersachsen",
      "lat": 52.20197,
      "lng": 8.33826,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Mellea"
      ],
      "population": 46514
    },
    {
      "name": "Meppen",
      "state": "Niedersachsen",
      "lat": 52.69064,
      "lng": 7.29097,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Mepen"
      ],
      "population": 34198
    },
    {
      "name": "Neustadt am Rübenberge",
      "state": "Niedersachsen",
      "lat": 52.50462,
      "lng": 9.45871,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Neustadt am Ruebenberge",
        "Neustadt am Rbge",
        "Nojshtadt-am-Rjubenberge"
      ],
      "population": 45942
    },
    {
      "name": "Nienburg/Weser",
      "state": "Niedersachsen",
      "lat": 52.6461,
      "lng": 9.22086,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Nienburg"
      ],
      "population": 32629
    },
    {
      "name": "Northeim",
      "state": "Niedersachsen",
      "lat": 51.70662,
      "lng": 9.99997,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 30894
    },
    {
      "name": "Oldenburg",
      "state": "Niedersachsen",
      "lat": 53.1435,
      "lng": 8.2146,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Ol'denburg",
        "Oldemburgh",
        "Oldemburgo",
        "Oldenbourg",
        "oldenburgi",
        "Oldenburgo",
        "Ol'dehnburg",
        "Oldenburgas",
        "Oldenburgum"
      ],
      "population": 159218
    },
    {
      "name": "Osterholz-Scharmbeck",
      "state": "Niedersachsen",
      "lat": 53.22698,
      "lng": 8.79528,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Osterkholc-Sharmbek",
        "Osterkhol'c-Sharmbek",
        "Oosterholt-Scharmbeek",
        "Stadt Osterholz-Scharmbeck"
      ],
      "population": 31405
    },
    {
      "name": "Papenburg",
      "state": "Niedersachsen",
      "lat": 53.07738,
      "lng": 7.40444,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "papnbwrg",
        "Papenbourg",
        "Papenburgo"
      ],
      "population": 34117
    },
    {
      "name": "Peine",
      "state": "Niedersachsen",
      "lat": 52.31928,
      "lng": 10.2352,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 49953
    },
    {
      "name": "Salzgitter",
      "state": "Niedersachsen",
      "lat": 52.15705,
      "lng": 10.4154,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 103866
    },
    {
      "name": "Seelze",
      "state": "Niedersachsen",
      "lat": 52.39635,
      "lng": 9.59727,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 32899
    },
    {
      "name": "Seevetal",
      "state": "Niedersachsen",
      "lat": 53.4,
      "lng": 9.96667,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Sevetalo",
        "Seevedaal"
      ],
      "population": 41266
    },
    {
      "name": "Stade",
      "state": "Niedersachsen",
      "lat": 53.59337,
      "lng": 9.47629,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Shtade",
        "shutade"
      ],
      "population": 45634
    },
    {
      "name": "Stuhr",
      "state": "Niedersachsen",
      "lat": 53.03333,
      "lng": 8.75,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 32507
    },
    {
      "name": "Uelzen",
      "state": "Niedersachsen",
      "lat": 52.96572,
      "lng": 10.56111,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 34996
    },
    {
      "name": "Wilhelmshaven",
      "state": "Niedersachsen",
      "lat": 53.52998,
      "lng": 8.11253,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Willemshaven"
      ],
      "population": 84393
    },
    {
      "name": "Winsen (Luhe)",
      "state": "Niedersachsen",
      "lat": 53.35753,
      "lng": 10.21282,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Winsen"
      ],
      "population": 32662
    },
    {
      "name": "Wolfenbüttel",
      "state": "Niedersachsen",
      "lat": 52.16442,
      "lng": 10.54095,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Wolfenbuettel",
        "Volfenbjutel",
        "Wulfenbüttel",
        "Wulfenbuettel",
        "Vol'fenbjuttel'"
      ],
      "population": 54740
    },
    {
      "name": "Wolfsburg",
      "state": "Niedersachsen",
      "lat": 52.42452,
      "lng": 10.7815,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Volfsburg",
        "Vol'fsburg",
        "Wolfsbourg",
        "Wolfsburgo"
      ],
      "population": 123064
    },
    {
      "name": "Wunstorf",
      "state": "Niedersachsen",
      "lat": 52.42377,
      "lng": 9.43585,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Vunstorf"
      ],
      "population": 42080
    },
    {
      "name": "Bad Harzburg",
      "state": "Niedersachsen",
      "lat": 51.88268,
      "lng": 10.56157,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Bad-Garcburg",
        "Bad Kharcburg",
        "Bad-Kharcburge"
      ],
      "population": 22954
    },
    {
      "name": "Cuxhaven",
      "state": "Niedersachsen",
      "lat": 53.8593,
      "lng": 8.6879,
      "type": "tourism",
      "hasZone": false,
      "aliases": [],
      "population": 52677
    },
    {
      "name": "Goslar",
      "state": "Niedersachsen",
      "lat": 51.90425,
      "lng": 10.42766,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "gslar",
        "Goslaer",
        "goslari",
        "Goslaria"
      ],
      "population": 43560
    },
    {
      "name": "Lüneburg",
      "state": "Niedersachsen",
      "lat": 53.2509,
      "lng": 10.41409,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Lineburg",
        "Luneberg",
        "Luneburk",
        "Ljuneburg",
        "Lueneburg",
        "Lunebourg",
        "Luneburgo",
        "Lyneburgu",
        "Luneburgum"
      ],
      "population": 71260
    },
    {
      "name": "Bad Bentheim",
      "state": "Niedersachsen",
      "lat": 52.30066,
      "lng": 7.15763,
      "type": "border",
      "hasZone": false,
      "aliases": [],
      "population": 15508
    },
    {
      "name": "Nordhorn",
      "state": "Niedersachsen",
      "lat": 52.43081,
      "lng": 7.06833,
      "type": "border",
      "hasZone": false,
      "aliases": [
        "Nordkhorn"
      ],
      "population": 52803
    },
    {
      "name": "Harz",
      "state": "Niedersachsen",
      "lat": 51.78,
      "lng": 10.61,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Harz Mountains"
      ]
    },
    {
      "name": "Lüneburger Heide",
      "state": "Niedersachsen",
      "lat": 53.15,
      "lng": 9.95,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Luneburg Heath",
        "Lueneburger Heide"
      ]
    },
    {
      "name": "Ahaus",
      "state": "Nordrhein-Westfalen",
      "lat": 52.07936,
      "lng": 7.01344,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Akhaus"
      ],
      "population": 38165
    },
    {
      "name": "Ahlen",
      "state": "Nordrhein-Westfalen",
      "lat": 51.76338,
      "lng": 7.8887,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 55280
    },
    {
      "name": "Alsdorf",
      "state": "Nordrhein-Westfalen",
      "lat": 50.87673,
      "lng": 6.16399,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "alsdwrf",
        "Al'sdorf"
      ],
      "population": 46340
    },
    {
      "name": "Arnsberg",
      "state": "Nordrhein-Westfalen",
      "lat": 51.38333,
      "lng": 8.08333,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "arnsbrg",
        "arnsbrgh",
        "Arensperg",
        "Arnsberga",
        "Arnsberge",
        "Arnsbergas"
      ],
      "population": 76612
    },
    {
      "name": "Bad Oeynhausen",
      "state": "Nordrhein-Westfalen",
      "lat": 52.20699,
      "lng": 8.80365,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bad Oeyhausen"
      ],
      "population": 49513
    },
    {
      "name": "Bad Salzuflen",
      "state": "Nordrhein-Westfalen",
      "lat": 52.0862,
      "lng": 8.74434,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bad Zalcuflen"
      ],
      "population": 54899
    },
    {
      "name": "Beckum",
      "state": "Nordrhein-Westfalen",
      "lat": 51.75571,
      "lng": 8.04075,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bekum",
        "Bekkum"
      ],
      "population": 37814
    },
    {
      "name": "Bergheim",
      "state": "Nordrhein-Westfalen",
      "lat": 50.95572,
      "lng": 6.63986,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bergem"
      ],
      "population": 63558
    },
    {
      "name": "Bergisch Gladbach",
      "state": "Nordrhein-Westfalen",
      "lat": 50.9856,
      "lng": 7.13298,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bergish Gladbakh"
      ],
      "population": 106184
    },
    {
      "name": "Bergkamen",
      "state": "Nordrhein-Westfalen",
      "lat": 51.61633,
      "lng": 7.64451,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "brgkamn",
        "Berkamen",
        "brghkamn",
        "Biaergkoamen"
      ],
      "population": 52329
    },
    {
      "name": "Bielefeld",
      "state": "Nordrhein-Westfalen",
      "lat": 52.0302,
      "lng": 8.5325,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bilefeld",
        "Bilifeld",
        "Bilefel'd",
        "Bilefelde",
        "Builefeld"
      ],
      "population": 331906
    },
    {
      "name": "Bocholt",
      "state": "Nordrhein-Westfalen",
      "lat": 51.83879,
      "lng": 6.61531,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bokholt"
      ],
      "population": 73943
    },
    {
      "name": "Borken",
      "state": "Nordrhein-Westfalen",
      "lat": 51.84382,
      "lng": 6.85774,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Buorken"
      ],
      "population": 40876
    },
    {
      "name": "Bornheim",
      "state": "Nordrhein-Westfalen",
      "lat": 50.76313,
      "lng": 6.99089,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 48523
    },
    {
      "name": "Brühl",
      "state": "Nordrhein-Westfalen",
      "lat": 50.82928,
      "lng": 6.90499,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bruehl"
      ],
      "population": 44137
    },
    {
      "name": "Bünde",
      "state": "Nordrhein-Westfalen",
      "lat": 52.19837,
      "lng": 8.58644,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Buende",
        "Bjunde",
        "byunde"
      ],
      "population": 45376
    },
    {
      "name": "Coesfeld",
      "state": "Nordrhein-Westfalen",
      "lat": 51.94349,
      "lng": 7.16809,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Koesfeld",
        "Cosfeldia"
      ],
      "population": 36631
    },
    {
      "name": "Datteln",
      "state": "Nordrhein-Westfalen",
      "lat": 51.65598,
      "lng": 7.3453,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "datln",
        "Dateln",
        "Dattel'n"
      ],
      "population": 36338
    },
    {
      "name": "Detmold",
      "state": "Nordrhein-Westfalen",
      "lat": 51.93855,
      "lng": 8.87318,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Detmol'd",
        "Detmolda",
        "Detmoldas"
      ],
      "population": 73680
    },
    {
      "name": "Dormagen",
      "state": "Nordrhein-Westfalen",
      "lat": 51.09683,
      "lng": 6.83167,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 63582
    },
    {
      "name": "Dorsten",
      "state": "Nordrhein-Westfalen",
      "lat": 51.66166,
      "lng": 6.96514,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 79981
    },
    {
      "name": "Dülmen",
      "state": "Nordrhein-Westfalen",
      "lat": 51.83149,
      "lng": 7.28075,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Duelmen",
        "Dilmen",
        "Dyulmen",
        "Djul'men",
        "Dulmenni"
      ],
      "population": 47495
    },
    {
      "name": "Düren",
      "state": "Nordrhein-Westfalen",
      "lat": 50.8043,
      "lng": 6.492,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Djuren",
        "Dueren"
      ],
      "population": 93440
    },
    {
      "name": "Emsdetten",
      "state": "Nordrhein-Westfalen",
      "lat": 52.1734,
      "lng": 7.52781,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Emsdeten",
        "Ehmsdetten"
      ],
      "population": 35582
    },
    {
      "name": "Ennepetal",
      "state": "Nordrhein-Westfalen",
      "lat": 51.29848,
      "lng": 7.3629,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Enepetal",
        "Ehnnepetal'"
      ],
      "population": 32607
    },
    {
      "name": "Erftstadt",
      "state": "Nordrhein-Westfalen",
      "lat": 50.81481,
      "lng": 6.79387,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Erftshtat",
        "Erftshtadt",
        "Ehrftshtadt"
      ],
      "population": 51207
    },
    {
      "name": "Erkelenz",
      "state": "Nordrhein-Westfalen",
      "lat": 51.07947,
      "lng": 6.31531,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Erkelenc",
        "Erkelens",
        "Ehrkelenc"
      ],
      "population": 44650
    },
    {
      "name": "Erkrath",
      "state": "Nordrhein-Westfalen",
      "lat": 51.22235,
      "lng": 6.90831,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Erkrat",
        "Ehrkrat"
      ],
      "population": 47815
    },
    {
      "name": "Euskirchen",
      "state": "Nordrhein-Westfalen",
      "lat": 50.66057,
      "lng": 6.78722,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 54889
    },
    {
      "name": "Frechen",
      "state": "Nordrhein-Westfalen",
      "lat": 50.91485,
      "lng": 6.8118,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Frechem",
        "Frekhen"
      ],
      "population": 48733
    },
    {
      "name": "Geldern",
      "state": "Nordrhein-Westfalen",
      "lat": 51.51908,
      "lng": 6.32363,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "gldrn",
        "Geldere",
        "Gel'dern",
        "Gel'dehrn"
      ],
      "population": 34013
    },
    {
      "name": "Gevelsberg",
      "state": "Nordrhein-Westfalen",
      "lat": 51.31971,
      "lng": 7.3392,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Gefel'sberg",
        "Gevel'sberg",
        "Gevelsbergum",
        "Gievelsbiaerg"
      ],
      "population": 32664
    },
    {
      "name": "Goch",
      "state": "Nordrhein-Westfalen",
      "lat": 51.67873,
      "lng": 6.15895,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 33706
    },
    {
      "name": "Greven",
      "state": "Nordrhein-Westfalen",
      "lat": 52.09364,
      "lng": 7.59396,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Grefen"
      ],
      "population": 35080
    },
    {
      "name": "Grevenbroich",
      "state": "Nordrhein-Westfalen",
      "lat": 51.09102,
      "lng": 6.5827,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Grevenbrokh",
        "Grevenbroikh",
        "Grevenbroichas"
      ],
      "population": 64779
    },
    {
      "name": "Gummersbach",
      "state": "Nordrhein-Westfalen",
      "lat": 51.02608,
      "lng": 7.56473,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Gumersbakh",
        "Gummersbakh"
      ],
      "population": 53131
    },
    {
      "name": "Gütersloh",
      "state": "Nordrhein-Westfalen",
      "lat": 51.90693,
      "lng": 8.37853,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Guetersloh",
        "Giuterslo",
        "Gjuterslo",
        "Giterslokh"
      ],
      "population": 96180
    },
    {
      "name": "Haltern am See",
      "state": "Nordrhein-Westfalen",
      "lat": 51.74297,
      "lng": 7.18163,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 37845
    },
    {
      "name": "Hamm",
      "state": "Nordrhein-Westfalen",
      "lat": 51.68033,
      "lng": 7.82089,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Khamm"
      ],
      "population": 178967
    },
    {
      "name": "Hattingen",
      "state": "Nordrhein-Westfalen",
      "lat": 51.39894,
      "lng": 7.18557,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Khatingen",
        "Khattingen"
      ],
      "population": 56866
    },
    {
      "name": "Heinsberg",
      "state": "Nordrhein-Westfalen",
      "lat": 51.06358,
      "lng": 6.0998,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Heinsburg"
      ],
      "population": 41505
    },
    {
      "name": "Hemer",
      "state": "Nordrhein-Westfalen",
      "lat": 51.38707,
      "lng": 7.77019,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Khemer"
      ],
      "population": 37502
    },
    {
      "name": "Hennef (Sieg)",
      "state": "Nordrhein-Westfalen",
      "lat": 50.77555,
      "lng": 7.28308,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 48002
    },
    {
      "name": "Herford",
      "state": "Nordrhein-Westfalen",
      "lat": 52.11457,
      "lng": 8.67343,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Herfordo",
        "Kherford"
      ],
      "population": 64879
    },
    {
      "name": "Herzogenrath",
      "state": "Nordrhein-Westfalen",
      "lat": 50.86874,
      "lng": 6.09317,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Khercogenrat"
      ],
      "population": 47381
    },
    {
      "name": "Hilden",
      "state": "Nordrhein-Westfalen",
      "lat": 51.16818,
      "lng": 6.93093,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Hilde",
        "Khilden",
        "Khil'den"
      ],
      "population": 56565
    },
    {
      "name": "Höxter",
      "state": "Nordrhein-Westfalen",
      "lat": 51.77501,
      "lng": 9.38155,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Hoexter"
      ],
      "population": 32713
    },
    {
      "name": "Hückelhoven",
      "state": "Nordrhein-Westfalen",
      "lat": 51.0555,
      "lng": 6.22658,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Hueckelhoven"
      ],
      "population": 39828
    },
    {
      "name": "Hürth",
      "state": "Nordrhein-Westfalen",
      "lat": 50.87079,
      "lng": 6.86761,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Huerth"
      ],
      "population": 54678
    },
    {
      "name": "Ibbenbüren",
      "state": "Nordrhein-Westfalen",
      "lat": 52.27964,
      "lng": 7.71457,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Ibbenbueren",
        "Ibenbiren",
        "Ibbenbjuren"
      ],
      "population": 50577
    },
    {
      "name": "Iserlohn",
      "state": "Nordrhein-Westfalen",
      "lat": 51.37547,
      "lng": 7.70281,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Iserlon"
      ],
      "population": 97910
    },
    {
      "name": "Jülich",
      "state": "Nordrhein-Westfalen",
      "lat": 50.92149,
      "lng": 6.36267,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Juelich",
        "Julikh",
        "Julichas"
      ],
      "population": 33911
    },
    {
      "name": "Kaarst",
      "state": "Nordrhein-Westfalen",
      "lat": 51.22929,
      "lng": 6.61883,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Karst"
      ],
      "population": 42112
    },
    {
      "name": "Kamen",
      "state": "Nordrhein-Westfalen",
      "lat": 51.59231,
      "lng": 7.6638,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "ka men",
        "Kameno"
      ],
      "population": 45927
    },
    {
      "name": "Kamp-Lintfort",
      "state": "Nordrhein-Westfalen",
      "lat": 51.50467,
      "lng": 6.54587,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 39490
    },
    {
      "name": "Kempen",
      "state": "Nordrhein-Westfalen",
      "lat": 51.36432,
      "lng": 6.41858,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 36312
    },
    {
      "name": "Kerpen",
      "state": "Nordrhein-Westfalen",
      "lat": 50.86991,
      "lng": 6.69691,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Kerpe"
      ],
      "population": 64226
    },
    {
      "name": "Korschenbroich",
      "state": "Nordrhein-Westfalen",
      "lat": 51.19139,
      "lng": 6.51352,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Korshenbroikh"
      ],
      "population": 33406
    },
    {
      "name": "Kreuztal",
      "state": "Nordrhein-Westfalen",
      "lat": 50.96775,
      "lng": 7.98848,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Kreuzthal"
      ],
      "population": 31772
    },
    {
      "name": "Königswinter",
      "state": "Nordrhein-Westfalen",
      "lat": 50.67734,
      "lng": 7.19245,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Koenigswinter",
        "Kenigsvinter",
        "Königsvinter",
        "K'onigsvinter",
        "Kjonigsvinter",
        "Koenigsvinter",
        "Konigsvintero"
      ],
      "population": 41164
    },
    {
      "name": "Lage",
      "state": "Nordrhein-Westfalen",
      "lat": 51.99223,
      "lng": 8.79301,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "la ge"
      ],
      "population": 34885
    },
    {
      "name": "Lemgo",
      "state": "Nordrhein-Westfalen",
      "lat": 52.02786,
      "lng": 8.89901,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 41943
    },
    {
      "name": "Leverkusen",
      "state": "Nordrhein-Westfalen",
      "lat": 51.0303,
      "lng": 6.98432,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Leverkuzen",
        "Leverkuzene"
      ],
      "population": 162738
    },
    {
      "name": "Lippstadt",
      "state": "Nordrhein-Westfalen",
      "lat": 51.67369,
      "lng": 8.34482,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Lipshtat",
        "Lippshtadt",
        "Lippshtadte"
      ],
      "population": 67219
    },
    {
      "name": "Lohmar",
      "state": "Nordrhein-Westfalen",
      "lat": 50.83868,
      "lng": 7.21399,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Lomar"
      ],
      "population": 31339
    },
    {
      "name": "Löhne",
      "state": "Nordrhein-Westfalen",
      "lat": 52.18848,
      "lng": 8.6922,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Loehne"
      ],
      "population": 39521
    },
    {
      "name": "Lüdenscheid",
      "state": "Nordrhein-Westfalen",
      "lat": 51.21977,
      "lng": 7.6273,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Luedenscheid",
        "Luensche",
        "Leudenscheid"
      ],
      "population": 79386
    },
    {
      "name": "Lünen",
      "state": "Nordrhein-Westfalen",
      "lat": 51.61634,
      "lng": 7.52872,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Luenen",
        "Ljunen",
        "lu nen"
      ],
      "population": 91009
    },
    {
      "name": "Marl",
      "state": "Nordrhein-Westfalen",
      "lat": 51.65671,
      "lng": 7.09038,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 91398
    },
    {
      "name": "Meerbusch",
      "state": "Nordrhein-Westfalen",
      "lat": 51.25268,
      "lng": 6.68807,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Merbush"
      ],
      "population": 54826
    },
    {
      "name": "Menden",
      "state": "Nordrhein-Westfalen",
      "lat": 51.44337,
      "lng": 7.77825,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Mennen",
        "men deng"
      ],
      "population": 52452
    },
    {
      "name": "Meschede",
      "state": "Nordrhein-Westfalen",
      "lat": 51.3502,
      "lng": 8.28332,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Meshede"
      ],
      "population": 32224
    },
    {
      "name": "Mettmann",
      "state": "Nordrhein-Westfalen",
      "lat": 51.2504,
      "lng": 6.97536,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Metman",
        "Mettman"
      ],
      "population": 39550
    },
    {
      "name": "Minden",
      "state": "Nordrhein-Westfalen",
      "lat": 52.28953,
      "lng": 8.91455,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Mindeno",
        "min dein"
      ],
      "population": 82879
    },
    {
      "name": "Moers",
      "state": "Nordrhein-Westfalen",
      "lat": 51.45342,
      "lng": 6.6326,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 103487
    },
    {
      "name": "Monheim am Rhein",
      "state": "Nordrhein-Westfalen",
      "lat": 51.09162,
      "lng": 6.89217,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 43038
    },
    {
      "name": "Nettetal",
      "state": "Nordrhein-Westfalen",
      "lat": 51.31667,
      "lng": 6.28333,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Netetal"
      ],
      "population": 42417
    },
    {
      "name": "Niederkassel",
      "state": "Nordrhein-Westfalen",
      "lat": 50.81503,
      "lng": 7.03777,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Niderkasel",
        "Neddekaaßel",
        "Niderkassel'"
      ],
      "population": 36480
    },
    {
      "name": "Oer-Erkenschwick",
      "state": "Nordrhein-Westfalen",
      "lat": 51.64198,
      "lng": 7.26451,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Er-Erkenshvik"
      ],
      "population": 30409
    },
    {
      "name": "Paderborn",
      "state": "Nordrhein-Westfalen",
      "lat": 51.7189,
      "lng": 8.7575,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "padrbwrn",
        "Padehrborn",
        "Paderborna",
        "Paderbornas"
      ],
      "population": 142161
    },
    {
      "name": "Porta Westfalica",
      "state": "Nordrhein-Westfalen",
      "lat": 52.22961,
      "lng": 8.91612,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 36364
    },
    {
      "name": "Pulheim",
      "state": "Nordrhein-Westfalen",
      "lat": 50.99965,
      "lng": 6.80632,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 53762
    },
    {
      "name": "Ratingen",
      "state": "Nordrhein-Westfalen",
      "lat": 51.29724,
      "lng": 6.84929,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "lating-en"
      ],
      "population": 91606
    },
    {
      "name": "Rheda-Wiedenbrück",
      "state": "Nordrhein-Westfalen",
      "lat": 51.84967,
      "lng": 8.30017,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Rheda-Wiedenbrueck"
      ],
      "population": 46123
    },
    {
      "name": "Rheinberg",
      "state": "Nordrhein-Westfalen",
      "lat": 51.54649,
      "lng": 6.59525,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 32188
    },
    {
      "name": "Rheine",
      "state": "Nordrhein-Westfalen",
      "lat": 52.28509,
      "lng": 7.44055,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 76491
    },
    {
      "name": "Sankt Augustin",
      "state": "Nordrhein-Westfalen",
      "lat": 50.77538,
      "lng": 7.197,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "St. Augustin",
        "Sankt-Avgustin",
        "Zankt-Augustin"
      ],
      "population": 56094
    },
    {
      "name": "Schwelm",
      "state": "Nordrhein-Westfalen",
      "lat": 51.28635,
      "lng": 7.29388,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "shwlm"
      ],
      "population": 30235
    },
    {
      "name": "Schwerte",
      "state": "Nordrhein-Westfalen",
      "lat": 51.44387,
      "lng": 7.5675,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Schweierte"
      ],
      "population": 50399
    },
    {
      "name": "Siegburg",
      "state": "Nordrhein-Westfalen",
      "lat": 50.80019,
      "lng": 7.20769,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Siegburgum"
      ],
      "population": 39135
    },
    {
      "name": "Soest",
      "state": "Nordrhein-Westfalen",
      "lat": 51.57558,
      "lng": 8.10619,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 48037
    },
    {
      "name": "Solingen",
      "state": "Nordrhein-Westfalen",
      "lat": 51.17343,
      "lng": 7.0845,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Zolingen",
        "Zolingene",
        "zolingeni",
        "suo lin gen"
      ],
      "population": 164359
    },
    {
      "name": "Steinfurt",
      "state": "Nordrhein-Westfalen",
      "lat": 52.15045,
      "lng": 7.33664,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 34601
    },
    {
      "name": "Stolberg",
      "state": "Nordrhein-Westfalen",
      "lat": 50.77368,
      "lng": 6.22595,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Shtolberg",
        "Sjtolberg",
        "Shtol'berg"
      ],
      "population": 56377
    },
    {
      "name": "Troisdorf",
      "state": "Nordrhein-Westfalen",
      "lat": 50.80901,
      "lng": 7.14968,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Trojsdorf"
      ],
      "population": 74749
    },
    {
      "name": "Tönisvorst",
      "state": "Nordrhein-Westfalen",
      "lat": 51.32092,
      "lng": 6.49412,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Toenisvorst",
        "Tenisvorst",
        "Tjonisforst"
      ],
      "population": 30296
    },
    {
      "name": "Unna",
      "state": "Nordrhein-Westfalen",
      "lat": 51.53795,
      "lng": 7.68969,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 66734
    },
    {
      "name": "Velbert",
      "state": "Nordrhein-Westfalen",
      "lat": 51.33537,
      "lng": 7.04348,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Felbert"
      ],
      "population": 87669
    },
    {
      "name": "Viersen",
      "state": "Nordrhein-Westfalen",
      "lat": 51.25435,
      "lng": 6.39441,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 76153
    },
    {
      "name": "Voerde",
      "state": "Nordrhein-Westfalen",
      "lat": 51.59703,
      "lng": 6.6863,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 36047
    },
    {
      "name": "Waltrop",
      "state": "Nordrhein-Westfalen",
      "lat": 51.62125,
      "lng": 7.40238,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Valtrop",
        "waltrwp"
      ],
      "population": 30220
    },
    {
      "name": "Warendorf",
      "state": "Nordrhein-Westfalen",
      "lat": 51.95109,
      "lng": 7.98756,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "warndwrf",
        "Varendorf",
        "Warendorp",
        "Varehndorf"
      ],
      "population": 38707
    },
    {
      "name": "Werl",
      "state": "Nordrhein-Westfalen",
      "lat": 51.55493,
      "lng": 7.91403,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Werle"
      ],
      "population": 32149
    },
    {
      "name": "Wermelskirchen",
      "state": "Nordrhein-Westfalen",
      "lat": 51.1397,
      "lng": 7.21583,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Vermelskirkhen",
        "Vermel'skirkhen"
      ],
      "population": 36816
    },
    {
      "name": "Werne",
      "state": "Nordrhein-Westfalen",
      "lat": 51.66446,
      "lng": 7.63421,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 30810
    },
    {
      "name": "Wesel",
      "state": "Nordrhein-Westfalen",
      "lat": 51.6669,
      "lng": 6.62037,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 61685
    },
    {
      "name": "Wesseling",
      "state": "Nordrhein-Westfalen",
      "lat": 50.82709,
      "lng": 6.9747,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Veseling",
        "Vesseling"
      ],
      "population": 35665
    },
    {
      "name": "Willich",
      "state": "Nordrhein-Westfalen",
      "lat": 51.26371,
      "lng": 6.54734,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 51843
    },
    {
      "name": "Witten",
      "state": "Nordrhein-Westfalen",
      "lat": 51.44362,
      "lng": 7.35258,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Vitten"
      ],
      "population": 101247
    },
    {
      "name": "Würselen",
      "state": "Nordrhein-Westfalen",
      "lat": 50.81809,
      "lng": 6.1347,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Wuerselen"
      ],
      "population": 37074
    },
    {
      "name": "Monschau",
      "state": "Nordrhein-Westfalen",
      "lat": 50.55462,
      "lng": 6.24001,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Monshau"
      ],
      "population": 12945
    },
    {
      "name": "Winterberg",
      "state": "Nordrhein-Westfalen",
      "lat": 51.192,
      "lng": 8.5348,
      "type": "tourism",
      "hasZone": false,
      "aliases": []
    },
    {
      "name": "Xanten",
      "state": "Nordrhein-Westfalen",
      "lat": 51.65877,
      "lng": 6.45297,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Santen"
      ],
      "population": 21587
    },
    {
      "name": "Emmerich am Rhein",
      "state": "Nordrhein-Westfalen",
      "lat": 51.83933,
      "lng": 6.24792,
      "type": "border",
      "hasZone": false,
      "aliases": [
        "Emmerich",
        "Ehmmerikh"
      ],
      "population": 30869
    },
    {
      "name": "Gronau (Westf.)",
      "state": "Nordrhein-Westfalen",
      "lat": 52.21099,
      "lng": 7.02238,
      "type": "border",
      "hasZone": false,
      "aliases": [
        "Gronau"
      ],
      "population": 46161
    },
    {
      "name": "Kleve",
      "state": "Nordrhein-Westfalen",
      "lat": 51.78826,
      "lng": 6.13865,
      "type": "border",
      "hasZone": false,
      "aliases": [
        "Cleves"
      ],
      "population": 49072
    },
    {
      "name": "Sauerland",
      "state": "Nordrhein-Westfalen",
      "lat": 51.2,
      "lng": 8.15,
      "type": "region",
      "hasZone": false,
      "aliases": []
    },
    {
      "name": "Teutoburger Wald",
      "state": "Nordrhein-Westfalen",
      "lat": 51.93,
      "lng": 8.82,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Teutoburg Forest"
      ]
    },
    {
      "name": "Deutsch-belgische Grenze",
      "state": "Nordrhein-Westfalen",
      "lat": 50.65,
      "lng": 6.15,
      "type": "border_region",
      "hasZone": false,
      "aliases": [
        "Belgian border",
        "Grenze Belgien",
        "German-Belgian border"
      ]
    },
    {
      "name": "Deutsch-niederländische Grenze",
      "state": "Nordrhein-Westfalen",
      "lat": 51.5,
      "lng": 6.3,
      "type": "border_region",
      "hasZone": false,
      "aliases": [
        "Dutch border",
        "Grenze Holland",
        "Grenze Niederlande",
        "German-Dutch border",
        "Deutsch-niederlaendische Grenze"
      ]
    },
    {
      "name": "Bad Kreuznach",
      "state": "Rheinland-Pfalz",
      "lat": 49.8414,
      "lng": 7.86713,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 43213
    },
    {
      "name": "Frankenthal",
      "state": "Rheinland-Pfalz",
      "lat": 49.53414,
      "lng": 8.35357,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "frakntal",
        "Frankental"
      ],
      "population": 47438
    },
    {
      "name": "Idar-Oberstein",
      "state": "Rheinland-Pfalz",
      "lat": 49.71443,
      "lng": 7.30776,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Idar-Obershtajn",
        "Idara-Obersteina"
      ],
      "population": 31610
    },
    {
      "name": "Kaiserslautern",
      "state": "Rheinland-Pfalz",
      "lat": 49.4401,
      "lng": 7.7491,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Kaiserlautern",
        "Kaiserslantern",
        "Kajzerslautern",
        "Kaizerslauternas"
      ],
      "population": 98732
    },
    {
      "name": "Koblenz",
      "state": "Rheinland-Pfalz",
      "lat": 50.3569,
      "lng": 7.589,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Coblenz",
        "Koblenc",
        "Coblence",
        "Koblentza"
      ],
      "population": 107319
    },
    {
      "name": "Landau in der Pfalz",
      "state": "Rheinland-Pfalz",
      "lat": 49.19844,
      "lng": 8.11692,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 41612
    },
    {
      "name": "Ludwigshafen am Rhein",
      "state": "Rheinland-Pfalz",
      "lat": 49.48121,
      "lng": 8.44641,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 163196
    },
    {
      "name": "Mainz",
      "state": "Rheinland-Pfalz",
      "lat": 49.9929,
      "lng": 8.2473,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Mayence"
      ],
      "population": 217123
    },
    {
      "name": "Neustadt an der Weinstraße",
      "state": "Rheinland-Pfalz",
      "lat": 49.35009,
      "lng": 8.13886,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 53984
    },
    {
      "name": "Neuwied",
      "state": "Rheinland-Pfalz",
      "lat": 50.4336,
      "lng": 7.47057,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Neuweid"
      ],
      "population": 66805
    },
    {
      "name": "Pirmasens",
      "state": "Rheinland-Pfalz",
      "lat": 49.20145,
      "lng": 7.60529,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Pirmazens"
      ],
      "population": 43582
    },
    {
      "name": "Speyer",
      "state": "Rheinland-Pfalz",
      "lat": 49.32083,
      "lng": 8.43111,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 50343
    },
    {
      "name": "Worms",
      "state": "Rheinland-Pfalz",
      "lat": 49.63278,
      "lng": 8.35916,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 81099
    },
    {
      "name": "Zweibrücken",
      "state": "Rheinland-Pfalz",
      "lat": 49.24686,
      "lng": 7.36977,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Deux-Ponts",
        "Zweibruecken"
      ],
      "population": 35221
    },
    {
      "name": "Bacharach",
      "state": "Rheinland-Pfalz",
      "lat": 50.05725,
      "lng": 7.76948,
      "type": "tourism",
      "hasZone": false,
      "aliases": [],
      "population": 2105
    },
    {
      "name": "Bernkastel-Kues",
      "state": "Rheinland-Pfalz",
      "lat": 49.91602,
      "lng": 7.07664,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Bernkastel",
        "Bernkastel'-Kus",
        "Bernkastel-Cues"
      ],
      "population": 6880
    },
    {
      "name": "Boppard",
      "state": "Rheinland-Pfalz",
      "lat": 50.23085,
      "lng": 7.58992,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Bopard"
      ],
      "population": 16215
    },
    {
      "name": "Cochem",
      "state": "Rheinland-Pfalz",
      "lat": 50.145,
      "lng": 7.1664,
      "type": "tourism",
      "hasZone": false,
      "aliases": []
    },
    {
      "name": "Sankt Goar",
      "state": "Rheinland-Pfalz",
      "lat": 50.14878,
      "lng": 7.7072,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Loreley",
        "St. Goar"
      ],
      "population": 3083
    },
    {
      "name": "Traben-Trarbach",
      "state": "Rheinland-Pfalz",
      "lat": 49.95076,
      "lng": 7.11562,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "trabn-trarbakh",
        "Traben-Trarbakh",
        "trabn-trarabakh"
      ],
      "population": 6018
    },
    {
      "name": "Trier",
      "state": "Rheinland-Pfalz",
      "lat": 49.7499,
      "lng": 6.6371,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Treier",
        "Treves"
      ],
      "population": 100129
    },
    {
      "name": "Wierschem",
      "state": "Rheinland-Pfalz",
      "lat": 50.22557,
      "lng": 7.35157,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Burg Eltz"
      ],
      "population": 323
    },
    {
      "name": "Bitburg",
      "state": "Rheinland-Pfalz",
      "lat": 49.96794,
      "lng": 6.52734,
      "type": "border",
      "hasZone": false,
      "aliases": [
        "Bitburgo"
      ],
      "population": 12908
    },
    {
      "name": "Eifel",
      "state": "Rheinland-Pfalz",
      "lat": 50.3,
      "lng": 6.6,
      "type": "region",
      "hasZone": false,
      "aliases": []
    },
    {
      "name": "Mittelrhein",
      "state": "Rheinland-Pfalz",
      "lat": 50.18,
      "lng": 7.68,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Rheintal",
        "Rhine Valley",
        "Romantischer Rhein",
        "Upper Middle Rhine Valley"
      ]
    },
    {
      "name": "Mosel",
      "state": "Rheinland-Pfalz",
      "lat": 49.95,
      "lng": 7.05,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Moseltal",
        "Moselle Valley",
        "Vallée de la Moselle"
      ]
    },
    {
      "name": "Deutsch-luxemburgische Grenze",
      "state": "Rheinland-Pfalz",
      "lat": 49.8,
      "lng": 6.35,
      "type": "border_region",
      "hasZone": false,
      "aliases": [
        "Grenze Luxemburg",
        "Luxembourg border",
        "German-Luxembourg border"
      ]
    },
    {
      "name": "Homburg",
      "state": "Saarland",
      "lat": 49.32637,
      "lng": 7.33867,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 44607
    },
    {
      "name": "Merzig",
      "state": "Saarland",
      "lat": 49.44331,
      "lng": 6.63874,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Mercig"
      ],
      "population": 31118
    },
    {
      "name": "Neunkirchen",
      "state": "Saarland",
      "lat": 49.34449,
      "lng": 7.18045,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 49843
    },
    {
      "name": "Saarbrücken",
      "state": "Saarland",
      "lat": 49.2402,
      "lng": 6.9969,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Saarbruken",
        "Sarbrukeno",
        "Sarrebruck",
        "Saarbrecken",
        "Saarbrjuken",
        "Saarbrükken",
        "Saarbrjukken",
        "Saarbruecken",
        "Saarbruekken"
      ],
      "population": 179349
    },
    {
      "name": "Sankt Ingbert",
      "state": "Saarland",
      "lat": 49.27697,
      "lng": 7.11672,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 38697
    },
    {
      "name": "Völklingen",
      "state": "Saarland",
      "lat": 49.25162,
      "lng": 6.85873,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Voelklingen"
      ],
      "population": 41132
    },
    {
      "name": "Saarlouis",
      "state": "Saarland",
      "lat": 49.31366,
      "lng": 6.75154,
      "type": "border",
      "hasZone": false,
      "aliases": [
        "Saarlui",
        "Saarluis",
        "Sarlouis",
        "Saarluise",
        "Sarrelouis"
      ],
      "population": 38333
    },
    {
      "name": "Bautzen",
      "state": "Sachsen",
      "lat": 51.18035,
      "lng": 14.43494,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Budysin",
        "Budziszyn",
        "Bautcen"
      ],
      "population": 41972
    },
    {
      "name": "Chemnitz",
      "state": "Sachsen",
      "lat": 50.8278,
      "lng": 12.9214,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 247220
    },
    {
      "name": "Dresden",
      "state": "Sachsen",
      "lat": 51.0504,
      "lng": 13.7373,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "drsdn",
        "Dresda",
        "Dresde",
        "Dresdn",
        "Drezno",
        "Drezden",
        "Drazdany",
        "dresdena",
        "Dresdeno",
        "doresuden",
        "Dresdenas"
      ],
      "population": 556227
    },
    {
      "name": "Freital",
      "state": "Sachsen",
      "lat": 51.00166,
      "lng": 13.6488,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Freitale",
        "Freithal"
      ],
      "population": 39027
    },
    {
      "name": "Hoyerswerda",
      "state": "Sachsen",
      "lat": 51.43787,
      "lng": 14.23549,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Hoyerwerda"
      ],
      "population": 43681
    },
    {
      "name": "Pirna",
      "state": "Sachsen",
      "lat": 50.95843,
      "lng": 13.93702,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 40322
    },
    {
      "name": "Plauen",
      "state": "Sachsen",
      "lat": 50.4973,
      "lng": 12.13782,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Plauehn",
        "Plauene",
        "Plauenas"
      ],
      "population": 66412
    },
    {
      "name": "Radebeul",
      "state": "Sachsen",
      "lat": 51.10654,
      "lng": 13.66047,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Radebeile"
      ],
      "population": 32643
    },
    {
      "name": "Riesa",
      "state": "Sachsen",
      "lat": 51.30777,
      "lng": 13.29168,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 37156
    },
    {
      "name": "Zwickau",
      "state": "Sachsen",
      "lat": 50.7189,
      "lng": 12.4961,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 98796
    },
    {
      "name": "Bad Schandau",
      "state": "Sachsen",
      "lat": 50.91743,
      "lng": 14.15494,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Sächsische Schweiz",
        "Saechsische Schweiz",
        "Bad Shandau",
        "bad shandaw",
        "bad shwandwa"
      ],
      "population": 3078
    },
    {
      "name": "Görlitz",
      "state": "Sachsen",
      "lat": 51.1523,
      "lng": 14.9872,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Goerlitz"
      ],
      "population": 57751
    },
    {
      "name": "Meißen",
      "state": "Sachsen",
      "lat": 51.16158,
      "lng": 13.4737,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Misen"
      ],
      "population": 28492
    },
    {
      "name": "Oberwiesenthal",
      "state": "Sachsen",
      "lat": 50.41943,
      "lng": 12.96836,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Kurort Oberwiesenthal"
      ],
      "population": 2592
    },
    {
      "name": "Zittau",
      "state": "Sachsen",
      "lat": 50.89772,
      "lng": 14.80764,
      "type": "border",
      "hasZone": false,
      "aliases": [
        "Cittau"
      ],
      "population": 25785
    },
    {
      "name": "Erzgebirge",
      "state": "Sachsen",
      "lat": 50.62,
      "lng": 13.05,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Ore Mountains"
      ]
    },
    {
      "name": "Sächsische Schweiz",
      "state": "Sachsen",
      "lat": 50.93,
      "lng": 14.18,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Saxon Switzerland",
        "Saechsische Schweiz"
      ]
    },
    {
      "name": "Bernburg",
      "state": "Sachsen-Anhalt",
      "lat": 51.79464,
      "lng": 11.7401,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Bernbourg"
      ],
      "population": 32113
    },
    {
      "name": "Dessau-Roßlau",
      "state": "Sachsen-Anhalt",
      "lat": 51.83864,
      "lng": 12.24555,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Dessau"
      ],
      "population": 67747
    },
    {
      "name": "Halberstadt",
      "state": "Sachsen-Anhalt",
      "lat": 51.89562,
      "lng": 11.05622,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Halberstatas",
        "Khalbershtat",
        "Halberstadium",
        "Khal'bershtadt"
      ],
      "population": 39729
    },
    {
      "name": "Lutherstadt Wittenberg",
      "state": "Sachsen-Anhalt",
      "lat": 51.8661,
      "lng": 12.64973,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Wittenberg"
      ],
      "population": 30000
    },
    {
      "name": "Merseburg",
      "state": "Sachsen-Anhalt",
      "lat": 51.35478,
      "lng": 11.98923,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Merzeburg",
        "Mersebourg",
        "Merseburga"
      ],
      "population": 34780
    },
    {
      "name": "Schönebeck",
      "state": "Sachsen-Anhalt",
      "lat": 52.01682,
      "lng": 11.7307,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Schoenebeck",
        "Shjonebek",
        "Schönnebeck",
        "Schoennebeck"
      ],
      "population": 30387
    },
    {
      "name": "Stendal",
      "state": "Sachsen-Anhalt",
      "lat": 52.6069,
      "lng": 11.85867,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "shtndal",
        "Shtendal",
        "Stendalia",
        "Stendalis",
        "syutendal"
      ],
      "population": 37722
    },
    {
      "name": "Quedlinburg",
      "state": "Sachsen-Anhalt",
      "lat": 51.78843,
      "lng": 11.15006,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Kwedlinburg",
        "Quedlimburgo",
        "Quedlinbourg",
        "Quedlinburgum"
      ],
      "population": 22814
    },
    {
      "name": "Sangerhausen",
      "state": "Sachsen-Anhalt",
      "lat": 51.47221,
      "lng": 11.29533,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Europa Rosarium"
      ],
      "population": 23347
    },
    {
      "name": "Wernigerode",
      "state": "Sachsen-Anhalt",
      "lat": 51.83652,
      "lng": 10.78216,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Vernigerode",
        "Vernigerodeh",
        "vuerunigerode"
      ],
      "population": 34463
    },
    {
      "name": "Ahrensburg",
      "state": "Schleswig-Holstein",
      "lat": 53.67515,
      "lng": 10.22593,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Arensburg",
        "Arensburgas"
      ],
      "population": 30103
    },
    {
      "name": "Elmshorn",
      "state": "Schleswig-Holstein",
      "lat": 53.74912,
      "lng": 9.66176,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Elmskhorn",
        "Elmshornas",
        "Ehl'mskhorn"
      ],
      "population": 48703
    },
    {
      "name": "Flensburg",
      "state": "Schleswig-Holstein",
      "lat": 54.7937,
      "lng": 9.4469,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "flnsbwrg",
        "Flensborg",
        "Flenzburg",
        "Flensborag",
        "Flensbourg",
        "Flensburga",
        "Flensburgh",
        "Flensburgo",
        "Flensburgas"
      ],
      "population": 85838
    },
    {
      "name": "Itzehoe",
      "state": "Schleswig-Holstein",
      "lat": 53.92099,
      "lng": 9.51529,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 33047
    },
    {
      "name": "Kiel",
      "state": "Schleswig-Holstein",
      "lat": 54.3233,
      "lng": 10.1228,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Kielo"
      ],
      "population": 246601
    },
    {
      "name": "Lübeck",
      "state": "Schleswig-Holstein",
      "lat": 53.8655,
      "lng": 10.6866,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Ljubek",
        "Lubeca",
        "Lubeka",
        "Lubeko",
        "Luebeck"
      ],
      "population": 212207
    },
    {
      "name": "Neumünster",
      "state": "Schleswig-Holstein",
      "lat": 54.07399,
      "lng": 9.98456,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Neumuenster",
        "Niemünster",
        "Niemuenster"
      ],
      "population": 80196
    },
    {
      "name": "Norderstedt",
      "state": "Schleswig-Holstein",
      "lat": 53.70177,
      "lng": 9.99328,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Nordershtet",
        "Nordershtedt"
      ],
      "population": 71439
    },
    {
      "name": "Pinneberg",
      "state": "Schleswig-Holstein",
      "lat": 53.65887,
      "lng": 9.79698,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Pineberg",
        "Pinnbarg",
        "Pinebergas"
      ],
      "population": 40577
    },
    {
      "name": "Wedel",
      "state": "Schleswig-Holstein",
      "lat": 53.58374,
      "lng": 9.69835,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 31995
    },
    {
      "name": "Büsum",
      "state": "Schleswig-Holstein",
      "lat": 54.13398,
      "lng": 8.85756,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Buesum"
      ],
      "population": 4904
    },
    {
      "name": "St. Peter-Ording",
      "state": "Schleswig-Holstein",
      "lat": 54.30363,
      "lng": 8.64138,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Sankt Peter-Ording",
        "Sankt Peter-Oring"
      ],
      "population": 4092
    },
    {
      "name": "Sylt",
      "state": "Schleswig-Holstein",
      "lat": 54.9079,
      "lng": 8.3036,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Westerland"
      ]
    },
    {
      "name": "Timmendorfer Strand",
      "state": "Schleswig-Holstein",
      "lat": 53.9953,
      "lng": 10.77676,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Timendorfer Shtrand",
        "Timmendorfer-Shtrand"
      ],
      "population": 9127
    },
    {
      "name": "Nordsee",
      "state": "Schleswig-Holstein",
      "lat": 54.3,
      "lng": 8.7,
      "type": "region",
      "hasZone": false,
      "aliases": [
        "Nordseeküste",
        "Nordseekueste",
        "North Sea coast"
      ]
    },
    {
      "name": "Deutsch-dänische Grenze",
      "state": "Schleswig-Holstein",
      "lat": 54.82,
      "lng": 9.35,
      "type": "border_region",
      "hasZone": false,
      "aliases": [
        "Danish border",
        "Grenze Dänemark",
        "Grenze Daenemark",
        "German-Danish border",
        "Deutsch-daenische Grenze"
      ]
    },
    {
      "name": "Altenburg",
      "state": "Thüringen",
      "lat": 50.98763,
      "lng": 12.43684,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "altnbrg",
        "altnbwrg",
        "Al'tenburg",
        "Altemburgo",
        "Altenbourg",
        "Altenburgo",
        "Altenburgas"
      ],
      "population": 38568
    },
    {
      "name": "Erfurt",
      "state": "Thüringen",
      "lat": 50.9848,
      "lng": 11.0299,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Ehrfurt",
        "Erfurte",
        "Erfurti",
        "Erfurto",
        "Erfurtas"
      ],
      "population": 213692
    },
    {
      "name": "Gera",
      "state": "Thüringen",
      "lat": 50.88029,
      "lng": 12.08187,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 104659
    },
    {
      "name": "Gotha",
      "state": "Thüringen",
      "lat": 50.94823,
      "lng": 10.70193,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 46615
    },
    {
      "name": "Jena",
      "state": "Thüringen",
      "lat": 50.9271,
      "lng": 11.5892,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 104712
    },
    {
      "name": "Mühlhausen",
      "state": "Thüringen",
      "lat": 51.20896,
      "lng": 10.45275,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Muehlhausen"
      ],
      "population": 38108
    },
    {
      "name": "Nordhausen",
      "state": "Thüringen",
      "lat": 51.5018,
      "lng": 10.7957,
      "type": "city",
      "hasZone": false,
      "aliases": [
        "Nordkhauzen"
      ],
      "population": 43912
    },
    {
      "name": "Suhl",
      "state": "Thüringen",
      "lat": 50.60911,
      "lng": 10.69401,
      "type": "city",
      "hasZone": false,
      "aliases": [],
      "population": 43509
    },
    {
      "name": "Eisenach",
      "state": "Thüringen",
      "lat": 50.9807,
      "lng": 10.3152,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Wartburg"
      ],
      "population": 43846
    },
    {
      "name": "Weimar",
      "state": "Thüringen",
      "lat": 50.9795,
      "lng": 11.3235,
      "type": "tourism",
      "hasZone": false,
      "aliases": [
        "Veimar",
        "wei ma",
        "wi mar"
      ],
      "population": 64727
    }
  ]
};
